import { IReviewResponse } from "@customTypes/modelResponses";
import CardWrapper from "@libs/cards/CardWrapper";
import ReviewCard, { ReviewCardSliderWrapper } from "@libs/cards/ReviewCard";
import styledParser from "@libs/parser/styled-parser";
import SliderCarousel from "@libs/slider/SliderCarousel";
import useSlider from "@libs/slider/hooks/useSlider";
import { useMemo } from "react";

const SLIDER_CONFIG = {
  desktop: {
    slidesToShow: 2,
    slidesToScroll: 2,
  },
  mobile: { class: "high-dots", dots: true },
};

interface IDetailsPageReviewsSectionProps {
  title?: string;
  reviewsData?: IReviewResponse[];
}

const DetailsPageReviewsSection = ({
  title,
  reviewsData,
}: IDetailsPageReviewsSectionProps): JSX.Element => {
  const cardComponents = useMemo(() => {
    return reviewsData?.map((review) => {
      return (
        <CardWrapper key={review?.id} widthPercentage={100}>
          <ReviewCard
            review={styledParser(review.ReviewText)}
            country={review?.Country}
            date={review?.Date}
            reviewer={review?.ReviewerName}
            headshot={review?.Headshot}
          />
        </CardWrapper>
      );
    });
  }, [reviewsData]);

  const { sliderSettings } = useSlider(SLIDER_CONFIG);

  return (
    <div className="mx-5 mt-[2.5rem] desktop:mx-0 desktop:mb-[4.5rem] desktop:max-w-[150rem]">
      <h2 className="mb-[2.563rem] max-w-[350px] text-h2 font-semibold desktop:mb-[4.125rem] desktop:max-w-none">
        {title} Reviews
      </h2>
      <div className="-ml-[0.6rem]">
        <ReviewCardSliderWrapper leftOffset="10px">
          <SliderCarousel
            components={cardComponents}
            settings={sliderSettings}
          />
        </ReviewCardSliderWrapper>
      </div>
    </div>
  );
};

export default DetailsPageReviewsSection;
